export default __webpack_public_path__ + "static/media/i108vp.b823a017.webp";